/** Canonical storefront origin — must be set at build via REACT_APP_SITE_URL for correct OG/canonical/prerender meta. */

export function trimOrigin(s) {
  return String(s || '')
    .trim()
    .replace(/\/+$/, '');
}

/** Origin used in meta tags (prefers explicit env over browser). Prerender/serve-localhost depends on env. */
export function getCanonicalSiteOrigin() {
  const fromEnv = trimOrigin(process.env.REACT_APP_SITE_URL);
  if (fromEnv && /^https?:\/\//i.test(fromEnv)) return fromEnv;
  if (typeof window !== 'undefined' && window.location?.origin)
    return trimOrigin(window.location.origin);
  return fromEnv || '';
}

export function absoluteCanonicalUrl(pathname) {
  const base = getCanonicalSiteOrigin();
  const path =
    pathname == null ? '/' : pathname.startsWith('/') ? pathname : `/${pathname}`;
  return base ? `${base}${path === '//' ? '/' : path}` : path;
}

/** Make image URL absolute for og:image — uses API-relative resolution when needed via getImageUrl. */
export function toAbsoluteOgImage(displayUrl, getResolvedUrl) {
  const resolved = typeof getResolvedUrl === 'function' ? getResolvedUrl(displayUrl || '') : displayUrl || '';
  const s = String(resolved || '').trim();
  if (!s) return '';
  if (s.startsWith('https://')) return s;
  if (s.startsWith('http://')) {
    try {
      const u = new URL(s);
      if (u.hostname === 'localhost' || u.hostname === '127.0.0.1') {
        const site = trimOrigin(process.env.REACT_APP_SITE_URL);
        if (site) return `${site}${u.pathname}${u.search}`;
      }
      return s;
    } catch (_) {
      return s;
    }
  }
  if (s.startsWith('//')) {
    const site = trimOrigin(process.env.REACT_APP_SITE_URL);
    if (/^https:/i.test(site)) return `https:${s}`;
    return `http:${s}`;
  }
  const origin = getCanonicalSiteOrigin();
  if (!origin && typeof window !== 'undefined' && window.location?.origin) {
    const o = trimOrigin(window.location.origin);
    const p = s.startsWith('/') ? s : `/${s}`;
    return `${o}${p}`;
  }
  if (!origin) return s.startsWith('/') ? s : `/${s}`;
  const p = s.startsWith('/') ? s : `/${s}`;
  return `${origin}${p}`;
}
